<template>
  <div class="h-full">
    <div class="mb-10"></div>
    <div
      class="mx-auto mb-2 max-w-sm w-4/5 bg-white border-t-4 border-blue-400 rounded shadow-lg hover:bg-gray-100"
      v-for="(item, index) in items"
      :key="index"
      @click="handleClick(item)"
    >
      <div class="flex items-center">
        <div
          class="flex-no-grow px-4 my-4 border-gray-500"
          :class="item.icon === null ? 'border-none' : 'border-r'"
          v-html="item.icon"
        ></div>
        <div class="flex-grow px-4 my-4 text-lg">
          {{ item.title || item.productName }}
        </div>
        <div class="flex-no-grow px-4 my-4">
          <svg
            class="text-gray-400 w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSulzerProductPage } from "@/api/index";

export default {
  name: "hello",
  data() {
    return {
      items: [],
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    handleClick(data) {
      this.$router.push({
        path: data.link || data.productUrl,
        query: {
          productId: data.productId,
        },
      });
    },
    async fetchData() {
      const { data } = await getSulzerProductPage({
        productType: this.$route.params.name,
        limit: 100000,
        page: 1,
      });
      this.items = data.data;
    },
  },
};
</script>
<style scoped></style>
